import init from '../../helpers/init';
import {showAlert} from '../main';

const {$} = init;
const BX = (<any>window).BX;

$(() => {
  $(document).on('click', '.js-read-notification', (e) => {
    e.preventDefault();
    const notificationId = $(e.currentTarget).data('id');

    const data = {
      notificationId
    };

    BX.ajax.runComponentAction('pwd:notifications.list', 'readNotification', {
      data,
      mode: 'class'
    }).then((result: any) => {
      if (parseInt(result.data) !== 0) {
        $(e.currentTarget).closest('.js-notification')
          .removeClass('bg-green-light');
        $(e.currentTarget).hide();
      }
    }).catch((err: any) => {
      showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
      console.log(err);
    });
  });

  $(document).on('click', '.js-read-all', (e) => {
    e.preventDefault();

    const data = {};

    BX.ajax.runComponentAction('pwd:notifications.list', 'readAll', {
      data,
      mode: 'class'
    }).then((result: any) => {
      if (parseInt(result.data) !== 0) {
        $('.js-notification').removeClass('bg-green-light');
        $('.js-read-notification').hide();
      }
    }).catch((err: any) => {
      showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
      console.log(err);
    });
  });

  $(document).on('click', '.js-notification .js-notification-block-item', function(){
    let p = $(this).parents('.js-notification');
    if(p.length){
      if(p.find('.js-read-notification').length){
        p.find('.js-read-notification').trigger('click');
      }
    }
  });
});
